import { useCallback } from 'react';
import type {
  DataMapGraphTree,
  DataMapGraphData,
} from '@/types/dataMap';
import {
  normalizeGraphTree,
  cloneGraphData,
  createGraphPayload,
} from '../utils/graphLayerHelpers';

interface UseDataMapFileOperationsProps {
  // getGraphTree: () => DataMapGraphTree;
  // onTreeImport?: (tree: DataMapGraphTree) => void;
  // onGraphDataChange?: (graphData: DataMapGraphData) => void;
  handleResetView?: () => void;
  lfRef: React.RefObject<any>;
}

export const useDataMapFileOperations = ({
  // getGraphTree,
  // onTreeImport,
  // onGraphDataChange,
  handleResetView,
  lfRef,
}: UseDataMapFileOperationsProps) => {
  // 保存当前画布数据到状态（用于持久化到父组件）
  const handleSave = useCallback(() => {
    if (!lfRef.current) return;

    try {
      const graphData = lfRef.current.getGraphData() as DataMapGraphData;
      console.log('💾 保存数据映射图数据:', graphData);

      // if (onGraphDataChange) {
      //   onGraphDataChange({
      //     ...graphData,
      //     _timestamp: Date.now(),
      //   });
      // }

      return graphData;
    } catch (error) {
      console.error('保存失败:', error);
      throw error;
    }
  }, [lfRef]); // [lfRef, onGraphDataChange]

  // 导出为 JSON 文件
  const handleExportJSON = useCallback(() => {
    // try {
    //   const tree = getGraphTree();
    //   const payload = createGraphPayload(tree);
    //   const jsonString = JSON.stringify(payload, null, 2);
    //   const blob = new Blob([jsonString], { type: 'application/json' });
    //   const url = URL.createObjectURL(blob);
    //   const link = document.createElement('a');
    //   link.href = url;
    //   link.download = `datamap-${new Date().toISOString().slice(0, 10)}.json`;
    //   document.body.appendChild(link);
    //   link.click();
    //   document.body.removeChild(link);
    //   URL.revokeObjectURL(url);
    //   console.log('✅ JSON导出成功');
    // } catch (error) {
    //   console.error('❌ JSON导出失败:', error);
    //   alert('JSON导出失败: ' + (error as Error).message);
    // }
  }, []); // [getGraphTree]

  // 导出为图片 (使用 LogicFlow 的 getSnapshot)
  const handleExportImage = useCallback(() => {
    try {
      if (!lfRef.current) {
        alert('画布未初始化');
        return;
      }

      // 获取画布快照
      const canvas = lfRef.current?.getSnapshot();
      if (!canvas) {
        alert('生成图片失败');
        return;
      }

      // 创建下载链接
      const url = canvas.toDataURL('image/png');
      const link = document.createElement('a');
      link.href = url;
      link.download = `datamap-${new Date().toISOString().slice(0, 10)}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log('✅ 图片导出成功');
    } catch (error) {
      console.error('❌ 图片导出失败:', error);
      alert('图片导出失败: ' + (error as Error).message);
    }
  }, [lfRef]);

  // 导入 JSON 文件
  const handleImportJSON = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = e => {
        try {
          const jsonString = e.target?.result as string;
          const parsed = JSON.parse(jsonString);
          const normalized = normalizeGraphTree(parsed);

          console.log('📥 导入数据映射图数据:', normalized);

          // if (onTreeImport) {
          //   onTreeImport(normalized);
          // }

          // 渲染导入的数据到画布
          if (lfRef.current && normalized[0]?.graphData) {
            lfRef.current.clearData();
            lfRef.current.render(normalized[0].graphData);
            lfRef.current.translateCenter();

            // 重置视图
            setTimeout(() => {
              handleResetView?.();
            }, 300);
          }

          console.log('✅ JSON导入成功');
        } catch (error) {
          console.error('❌ JSON导入失败:', error);
          alert('JSON导入失败: ' + (error as Error).message);
        }
      };

      reader.onerror = () => {
        alert('文件读取失败');
      };
      reader.readAsText(file);
      event.target.value = '';
    },
    [lfRef, handleResetView] //  [lfRef, handleResetView, onTreeImport]
  );

  // 导出当前画布数据（不包含树结构，仅当前层）
  const handleExportGraphData = useCallback(() => {
    try {
      if (!lfRef.current) {
        alert('画布未初始化');
        return;
      }

      const graphData = lfRef.current.getGraphData() as DataMapGraphData;
      const jsonString = JSON.stringify(graphData, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `datamap-graph-${new Date().toISOString().slice(0, 10)}.json`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
      console.log('✅ 图数据导出成功');
    } catch (error) {
      console.error('❌ 图数据导出失败:', error);
      alert('图数据导出失败: ' + (error as Error).message);
    }
  }, [lfRef]);

  return {
    handleSave,
    handleExportJSON,
    handleExportImage,
    handleExportGraphData,
    handleImportJSON,
  };
};
